import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4","key":"svg-0"}]]

const IconBrandTelegram = createReactComponent('outline', 'brand-telegram', 'BrandTelegram', __iconNode);

export default IconBrandTelegram;